export const environment = {
	production: false,
	environmentName: 'staging',
	showEnvBanner: true,
	apiUrl: 'https://staging-dmehs.dmehospicesolutions.com/api/v1/',
	webUrl: 'https://staging-dmehs.dmehospicesolutions.com',
	googleMapsApiKey: 'AIzaSyBR3jyQ-VALLsx22lRprpea02wNBAh79fE', // TODO: move to aws
	authClientSecret: 'srKHlpLcnyLaBhZmQsAIuztgY7C0N8gjZPFKjYgu', // TODO: move to aws

	// Mapbox
	mapboxAccessToken: 'pk.eyJ1IjoiZG1laHMiLCJhIjoiY21xZ3pwZGlwMDVpcDJycHczYXk4c3BmOSJ9.CD95t-ilJyRiTy-y56FIVw',

	// Broadcasting Configuration
	broadcastDriver: 'reverb', // 'pusher' or 'reverb'

	// Pusher Configuration
	pusherKey: 'qudumhfnjxz4tjtrzdjr',
	pusherCluster: 'us2',

	// Reverb Configuration (Laravel's new broadcasting service)

	// Local
	reverbKey: 'cbhska2wxjhk6divbhgq',
	reverbHost: 'staging-dmehs.dmehospicesolutions.com',
	reverbPort: 443,

	// Production
	// reverbKey: 'cbhska2wxjhk6divbhgq',
	// reverbHost: 'dev-new.dmehospicesolutions.com',
	// reverbPort: 443
	// reverbPath: '/app' // Add this line

	// Idle Timeout Configuration
	idleTimeoutMs: 2 * 60 * 60 * 1000, // DOVE-2374 — 2 hours
	idleWarningMs: (2 * 60 - 5) * 60 * 1000, // 1h 55min (show modal with 5 min countdown)
	activityThrottleMs: 1000, // Throttle activity events to max 1 per second
	keepAliveIntervalMs: 5 * 60 * 1000, // Ping server every 5 minutes
	countdownIntervalMs: 1000, // Update countdown every second
	idleStorageKey: 'dme_lastActivity',
	sessionEventKey: 'dme_sessionEvent' // Cross-tab session event signaling (warning/expired)
};
